import {
  submitConfigurables,
  useConfigurablesForm,
} from "../configurables/useConfigurablesForm";
import { useRolesForm } from "../roles/useRolesForm";
import { submitRoles, submitUsers } from "../submission/useSubmission";
import { useUsersForm } from "../users/useUsersForm";

import {
  locationFormRoutes,
  locationFormSubmit,
} from "../../components/pages/location/LocationRoute";

import {
  streetFormRoutes,
  streetFormSubmit,
} from "../../components/pages/parking/SmartParkingRoute";
import {
  onPasswordResetFormSubmit,
  usePasswordResetForm,
} from "../users/usePasswordResetForm";

import { submitLedgers, useLedgersForm } from "../ledgers/useLedgersForm";
import {
  bookingsFormRoutes,
  bookingsFormSubmit,
} from "../../components/pages/parking/ReservationRoutes";
import {
  clampingFormRoutes,
  clampingFormSubmit,
} from "../../components/pages/parking/ClampingRoutes";
import {
  submitVehicleTypes,
  useVehicleTypesForm,
} from "../configurables/useVehicleTypes";
import { useWagesConfigurationsForm } from "../wages/useWagesConfigurationsForm";
import { useWagesBonusForm } from "../wages/useWagesBonusForm";
import { useFixedWageForm } from "../wages/useFixedWageForm";
import { usePayWeekConfigurationForm } from "../wages/usePayWeekForm";
import { useWageAdvancementsForm } from "../wages/useWageAdvancementsForm";
import { assetFormRoutes } from "../../components/pages/assets/AssetRoutes";
import { usePettyCashRequisitionForm } from "../wages/requisition/usePettyCashRequisitionForm";
import { deploymentFormRoutes } from "../../components/pages/deployments/DeploymentRoutes";

// handle form creation
export const formHooks: Record<string, any> = {
  users: useUsersForm,
  roles: useRolesForm,
  // CONFIGURABLES
  configurables: useConfigurablesForm,
  vehicle_types: useVehicleTypesForm,

  // STREET CONFIG DATA
  ...streetFormRoutes,

  //BOOKINGS
  ...bookingsFormRoutes,

  //CLAMPING
  ...clampingFormRoutes,

  // MASTER DATA
  ...locationFormRoutes,

  // PASSWORD RESET
  password_reset: usePasswordResetForm,
  // LEDGERS
  ledgers: useLedgersForm,

  //WAGES
  wages_configurations: useWagesConfigurationsForm,
  wages_bonus: useWagesBonusForm,
  fixed_wages: useFixedWageForm,
  pay_week_configuration: usePayWeekConfigurationForm,
  wage_advancements: useWageAdvancementsForm,
  petty_cash_requisition: usePettyCashRequisitionForm,

  //ASSETS
  ...assetFormRoutes,

  //DEPLOYMENTS
  ...deploymentFormRoutes,
};

// handle form submission
export const formSubmitHooks: Record<string, any> = {
  users: submitUsers,
  // ROLES
  roles: submitRoles,
  // CONFIGURABLES
  configurables: submitConfigurables,
  vehicle_types: submitVehicleTypes,
  // MASTER DATA
  ...locationFormSubmit,

  // STREET DATA
  ...streetFormSubmit,

  //BOOKINGS
  ...bookingsFormSubmit,

  //CLAMPING
  ...clampingFormSubmit,

  // PASSWORD RESET
  password_reset: onPasswordResetFormSubmit,
  // LEDGERS
  ledgers: submitLedgers,
};
